import React from "react";
import { Redirect } from "react-router-dom";
import { Form, Message } from "semantic-ui-react";
import styled from "styled-components";
import IdentityApi from "../api/IdentityApi";
import { Paths } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import MainContentWrapper from "./common/MainContentWrapper";
import PillButton from "./common/PillButton";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import ErrorDisplay from "./ErrorDisplay";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 100;
`;

const HeaderText = styled.div`
  font-size: 16px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 20px;
  margin-top: 50px;
  text-align: center;
`;

class RequestPasswordChange extends BaseComponent {
  constructor() {
    super();
    this.state = {
      email: null,
      buttonDisabled: false,
      loaderActive: false,
      showMessage: false,
    };
    this.requestPasswordChange = this.requestPasswordChange.bind(this);
  }

  async requestPasswordChange() {
    const email = this.state.email;
    this.errorManager.reset();

    if (email === null) {
      this.errorManager.addError(
        "You must enter your email to send a password reminder"
      );
      this.forceUpdate();
      return;
    }
    this.setState({ loaderActive: true });
    this.setState({ buttonDisabled: true });
    this.forceUpdate();

    const trimmedEmail = String.prototype.trim.call(email);
    const auth = new IdentityApi();

    try {
      await auth.requestPasswordChange(trimmedEmail);
    } catch (err) {
      this.errorManager.addError("Uknown Error");
    }
    this.setState({ buttonDisabled: false });
    this.setState({ loaderActive: false });
    this.setState({ showMessage: true });
    this.forceUpdate();
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Password Reset" />
        <SFLoader active={this.state.loaderActive} />
        <MainContentWrapper>
          <Wrapper>
            <HeaderText>
              Enter your email below and click 'Send Reset Email' to reset your
              SafeFun password.
            </HeaderText>
            <Form.Input
              style={{ marginTop: 20, marginBottom: 20, width: 300 }}
              onChange={(e) => {
                this.setState({ email: e.target.value });
              }}
              placeholder="Enter e-mail"
              autoComplete="username"
            />
            <PillButton
              style={{ width: "200px", marginBottom: 20 }}
              onClick={() => {
                this.requestPasswordChange();
              }}
              primary
              loading={this.state.buttonDisabled}
            >
              Send Reset Email
            </PillButton>
            <PillButton
              style={{ width: "200px" }}
              onClick={() => {
                this.redirect(Paths.LOGIN);
              }}
              primary
            >
              Login
            </PillButton>
            {this.state.showMessage ? (
              <Message>
                If the email entered is associated with a SafeFun account, a
                password reset message will be sent to that address.
              </Message>
            ) : null}
            {this.errorManager.getErrorCount() > 0 ? (
              <ErrorDisplay errorManager={this.errorManager} />
            ) : null}
          </Wrapper>
        </MainContentWrapper>
      </SiteWrapper>
    );
  }
}

export default RequestPasswordChange;
